const initialState = {
  type: ''
};

const footerReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_FOOTER_ClICK_TYPE': {
      return {
        type: action.value
      };
    }
    default:
      return state;
  }
};

export default footerReducer;
